import { createFileRoute, redirect } from '@tanstack/react-router';
import { useCurrentRound, useStore } from 'engine/store';
import { TaskListScreen } from './rounds/$roundId';
import { EmptyStateComponent } from 'components/EmptyStateComponent';
import { Sparkles } from 'lucide-react';
import { redirectBasedOnPlayState } from 'engine/api';

export const Route = createFileRoute('/current-round')({
	component: RouteComponent,
	beforeLoad: async () => {
		const { game } = useStore.getState();

		if (!game) {
			throw redirect({
				to: '/',
			});
		}

		redirectBasedOnPlayState(location as unknown as Location);

		if (game.automaticNavigation !== 'per-round') {
			// you should not be here
			throw redirect({
				to: '/',
			});
		}
	},
});

function RouteComponent() {
	const currentRound = useCurrentRound();
	return (
		<>
			{currentRound && <TaskListScreen round={currentRound} />}
			{!currentRound && (
				<EmptyStateComponent icon={Sparkles} title="No current round" description="Wait for game master to start the next round." />
			)}
		</>
	);
}
